<div class="container flex-container">
  <div class="panel-content">
    <form
      class="form-container"
      [formGroup]="companyInformationForm"
      (ngSubmit)="save()"
    >
      <div class="form-group"></div>

      <div class="input-section-text">
        <mat-form-field id="businessType" appearance="outline" style="width: 30%; margin-right: 50px">
          <mat-label>Business Type</mat-label>
          <mat-select formControlName="businessType">
            <mat-option value="Corporation">Corporation</mat-option>
            <mat-option value="Partnership">Partnership</mat-option>
            <mat-option value="Sole Proprietorship">Sole Proprietorship</mat-option>
          </mat-select>
          <mat-error><em class="error-hint"> Required</em></mat-error>
        </mat-form-field>

        <mat-form-field id="companyName" appearance="outline" style="width: 35%; margin-right: 50px;">
          <mat-label>Company Name</mat-label>
          <input
            matInput
            placeholder="Company Name"
            formControlName="companyName"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('companyName')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('companyName')?.hasError('pattern')"> Cannot be blank</em>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-section-text">

        <mat-form-field id="LegalName" appearance="outline" style="width: 80%">
          <mat-label>Legal Name</mat-label>
          <input
            matInput
            placeholder="Legal Name"
            formControlName="legalName"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('legalName')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('legalName')?.hasError('pattern')"> Cannot be blank</em>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-section-text">
        <mat-form-field id="registrationNumber" appearance="outline" style="width: 30%; margin-right: 50px">
          <mat-label>Business Registration Number</mat-label>
          <input
            matInput
            placeholder="Business Registration Number"
            formControlName="registrationNumber"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('registrationNumber')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('registrationNumber')?.hasError('pattern')"> Cannot be blank</em>
          </mat-error>
        </mat-form-field>

        <mat-form-field id="companyWebsite" appearance="outline" style="width: 45%">
          <mat-label>Website</mat-label>
          <input
            matInput
            placeholder="Company Website"
            formControlName="companyWebsite"
          />
        </mat-form-field>
      </div>


      <div class="input-section" style="margin-bottom: 10px">
        <mat-label class="row-label">Registered Canadian Business? *</mat-label>
        <mat-radio-group
          aria-label="Registered Canadian Business?"
          class="radio-group"
          formControlName="registeredCanadianBusiness"
        >
          <div class="radio-option">
            <mat-radio-button class="radio-option" [value]="true" style="margin-right: 40px"
              >Yes</mat-radio-button
            >
             <mat-radio-button class="radio-option" [value]="false"
              >No</mat-radio-button
            >
          </div>
        </mat-radio-group>
        <em
          class="error-hint"
          *ngIf="companyInformationForm.get('registeredCanadianBusiness')?.invalid && companyInformationForm.get('registeredCanadianBusiness')?.touched"
        >
          Required
        </em>
      </div>

      <div class="countries-row" *ngIf="!isLoadingCountries">
        <div class="country-selection-box">
          <mat-label class="row-label">Registered Countries of Recruitment (Top 3) *</mat-label>
          <br /><br />

          <mat-chip-set class="selected-countries-chips" *ngIf="getSelectedCountries().length > 0">
            <mat-chip
              *ngFor="let country of getSelectedCountries()"
              [removable]="!companyInformationForm.get('registeredCountries')?.disabled"
              (removed)="removeCountry(country.Code)"
            >
              {{ country.Name }}
              <button matChipRemove *ngIf="!companyInformationForm.get('registeredCountries')?.disabled">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-set>

          <mat-form-field class="search-box" appearance="outline" style="width: 100%; padding: 0 10px;">
            <mat-label>Search countries...</mat-label>
            <input matInput [formControl]="searchCountries" placeholder="Type to filter..." [disabled]="companyInformationForm.get('registeredCountries')?.disabled" (keydown.enter)="onEnterCountries($event)" />
          </mat-form-field>

          <div class="list-container">
            <mat-selection-list
              id="registeredCountries"
              (selectionChange)="onSelectionChange($event)"
              class="country-scroll-list"
              [disabled]="companyInformationForm.get('registeredCountries')?.disabled"
            >
              <mat-list-option
                *ngFor="let country of $searchCountries | async"
                [value]="country.Code"
                [selected]="isCountrySelected(country.Code)"
              >
                {{ country.Name }}
              </mat-list-option>
            </mat-selection-list>
          </div>
          <em
            class="error-hint"
            *ngIf="companyInformationForm.get('registeredCountries')?.invalid && companyInformationForm.get('registeredCountries')?.touched"
          >
            Select at least 1 country (up to 3)
          </em>
        </div>

        <div class="country-selection-box">
          <mat-label class="row-label">Nationalities of Students (Top 3) *</mat-label>
          <br /><br />

          <mat-chip-set class="selected-countries-chips" *ngIf="getSelectedStudentCountries().length > 0">
            <mat-chip
              *ngFor="let country of getSelectedStudentCountries()"
              [removable]="!companyInformationForm.get('registeredStudentCountries')?.disabled"
              (removed)="removeStudentCountry(country.Code)"
            >
              {{ country.Name }}
              <button matChipRemove *ngIf="!companyInformationForm.get('registeredStudentCountries')?.disabled">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-set>

          <mat-form-field class="search-box" appearance="outline" style="width: 100%; padding: 0 10px;">
            <mat-label>Search nationalities...</mat-label>
            <input matInput [formControl]="searchStudentCountries" placeholder="Type to filter..." [disabled]="companyInformationForm.get('registeredStudentCountries')?.disabled" (keydown.enter)="onEnterStudentCountries($event)" />
          </mat-form-field>

          <div class="list-container">
            <mat-selection-list
              id="registeredStudentCountries"
              (selectionChange)="onSelectionChangeStudent($event)"
              class="country-scroll-list"
              [disabled]="companyInformationForm.get('registeredStudentCountries')?.disabled"
            >
              <mat-list-option
                *ngFor="let country of $searchStudentCountries | async"
                [value]="country.Code"
                [selected]="isStudentCountrySelected(country.Code)"
              >
                {{ country.Name }}
              </mat-list-option>
            </mat-selection-list>
          </div>
          <em
            class="error-hint"
            *ngIf="companyInformationForm.get('registeredStudentCountries')?.invalid && companyInformationForm.get('registeredStudentCountries')?.touched"
          >
            Select at least 1 nationality (up to 3)
          </em>
        </div>
      </div>

      <div class="input-section input-row">
        <mat-label class="row-label">Company Contact Information</mat-label>
        <mat-form-field id="contactTitle" appearance="outline">
          <mat-label>Contact Title</mat-label>
          <input
            matInput
            placeholder="Contact Title"
            formControlName="contactTitle"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('contactTitle')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('contactTitle')?.hasError('pattern')"> Cannot be blank</em>
          </mat-error>
        </mat-form-field>

        <mat-form-field id="contactName" appearance="outline">
          <mat-label>Contact Name</mat-label>
          <input
            matInput
            placeholder="Contact Name"
            formControlName="contactName"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('contactName')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('contactName')?.hasError('pattern')"> Invalid contact name</em>
          </mat-error>
        </mat-form-field>

        <mat-form-field id="email" appearance="outline">
          <mat-label>Email</mat-label>
          <input
            matInput
            placeholder="Email"
            formControlName="email"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('email')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('email')?.hasError('email')"> Invalid email</em>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-section input-row">
        <mat-form-field id="address1" appearance="outline">
          <mat-label>Address Line 1</mat-label>
          <input
            matInput
            placeholder="Address Line 1"
            formControlName="address1"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('address1')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('address1')?.hasError('pattern')"> Cannot be blank</em>
          </mat-error>
        </mat-form-field>

        <mat-form-field id="address2" appearance="outline">
          <mat-label>Address Line 2</mat-label>
          <input
            matInput
            placeholder="Address Line 2"
            formControlName="address2"
          />
        </mat-form-field>

        <mat-form-field id="city" appearance="outline">
          <mat-label>City</mat-label>
          <input matInput placeholder="City" formControlName="city" />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('city')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('city')?.hasError('pattern')"> Cannot be blank</em>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-section input-row">
        <mat-form-field id="postalCode" appearance="outline">
          <mat-label>Postal Code</mat-label>
          <input
            matInput
            placeholder="Postal Code"
            formControlName="postalCode"
          />
        </mat-form-field>

        <mat-form-field id="state" appearance="outline">
          <mat-label>State</mat-label>
          <input
            matInput
            placeholder="State"
            formControlName="state"
          />
        </mat-form-field>

        <mat-form-field id="country" appearance="outline">
          <mat-label>Country</mat-label>
          <mat-select name="registeredCountry3" formControlName="country">
            <mat-option
              *ngFor="let country of countryList"
              [value]="country.Code"
            >
              {{ country.Name }}
            </mat-option>
          </mat-select>
          <mat-error><em class="error-hint"> Required</em></mat-error>
        </mat-form-field>
      </div>

      <div class="input-section">
        <mat-form-field
          id="phoneCountryCode"
          appearance="outline"
          style="margin-right: 120px"
        >
          <mat-label>Phone Country Code</mat-label>
          <input
            matInput
            placeholder="Phone Country Code"
            formControlName="phoneCountryCode"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('phoneCountryCode')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('phoneCountryCode')?.hasError('pattern')"> Optional + and 1–3 digits</em>
          </mat-error>
        </mat-form-field>

        <mat-form-field id="phone" appearance="outline">
          <mat-label>Phone Number</mat-label>
          <input
            matInput
            placeholder="Phone Number"
            formControlName="phone"
          />
          <mat-error>
            <em class="error-hint" *ngIf="companyInformationForm.get('phone')?.hasError('required')"> Required</em>
            <em class="error-hint" *ngIf="companyInformationForm.get('phone')?.hasError('pattern') || companyInformationForm.get('phone')?.hasError('minlength')"> 7–12 digits</em>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="button-section">
        <button
          *ngIf="showFillTestDataButton"
          mat-stroked-button
          type="button"
          class="seneca-button"
          color="primary"
          (click)="fillTestData()"
        >
          <span>Fill Test Data</span>
        </button>
        &nbsp;
        <button
          *ngIf="!isSaved; else elseBlock"
          mat-flat-button
          type="submit"
          class="seneca-button"
          color="primary"
          [disabled]="companyInformationForm.invalid"
        >
          Save
        </button>
        <ng-template #elseBlock>
          <button
            mat-flat-button
            class="seneca-button"
            color="primary"
            [disabled]="true"
          >
            Saved
          </button>
        </ng-template>
        <span class="divider"></span>
      </div>
    </form>
  </div>
</div>
